import { debounceTime } from 'rxjs/operators';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Site } from './mockSite';
import { Router, ActivatedRoute, Params, RouterLink } from '@angular/router';
import { OrganizationService } from '../../shared/services/organization.service';
import { MatSnackBar } from '@angular/material';
import { StaticValueService } from '../../shared/services/static-value.service';
import { AuthService } from '../../shared/services//auth/auth.service';
import { AssociateService } from 'app/associate/shared/services/associate.service';
import { NotificationService } from '../../shared/services/notification.service';
import { ToastService } from '../../shared/services/toast.service';


@Component({
    selector: 'app-site-new',
    templateUrl: './site-new.component.html',
    styleUrls: ['./site-new.component.css']
})
export class SiteNewComponent implements OnInit {
    @ViewChild('myForm')
    public myForm: NgForm;
    public staticDDlist: any;
    public organizationId: string;
    public dropDowns: any;
    public autoCompleteAssociate: any;
    public keyCounterAssc = 0;
    public digitalSiteList = [];
    public physicalSiteList = [];
    public sitePurposeDropDown = [];
    public mask;
    site: any = Object.assign({}, new Site().site);
    constructor(public organizationService: OrganizationService,
        public router: Router,
        public route: ActivatedRoute,
        public matsnackBar: MatSnackBar,
        public authService: AuthService,
        public staticDataService: StaticValueService,
        public toastService: ToastService,
        public associateService: AssociateService,
        public notificationService: NotificationService) { 

            this.staticDDlist = this.staticDataService.staticData.staticDD;
            this.digitalSiteList = JSON.parse(JSON.stringify(this.staticDDlist['site']['digitalType']));
            this.physicalSiteList = JSON.parse(JSON.stringify(this.staticDDlist['site']['physicalType']));
    
        }

    ngOnInit() {
        // phone number mask
        this.mask = this.authService.phoneNumberMaskObject;
        if (this.organizationService.companyName === undefined) {
            this.router.navigate(['/home/organization/organization-list']);
        }
        this.route.params.subscribe(params => {
            this.organizationId = params['organization_id'];
        });
        this.site.siteDetails.company.name = this.organizationService.companyName;
    }

    save() {
        this.site.organizationId = this.organizationId;
        this.site.siteDetails.company.name = this.organizationService.companyName;
        this.site.siteDetails.company.id = this.organizationId;
        let tempLastEdited = {
            'time': new Date(),
            // tslint:disable-next-line:max-line-length
            'name': this.authService.user.isProxyUser ? this.authService.user.name + ` (${this.authService.user.proxyUser.fullName})` : this.authService.user.name,
            'id': this.authService.user.associateId
        };
        this.site.siteDetails.lastEditedBy = Object.assign({}, tempLastEdited);
        this.site.contactDetails.lastEditedBy = Object.assign({}, tempLastEdited);
        this.site.lastEdited.push(tempLastEdited);
        this.organizationService.createSite(this.site).subscribe((data) => {
            // send notification to site Leader
            this.notificationService.sendNotification(this.site.contactDetails.siteLeader.id,
                `Site <b>${this.site.siteDetails.siteName}</b> has been added  `,
                'Organization', `home/organization/site-profile/view/${data['_id']}`);
            this.notificationService.sendNotification(this.site.contactDetails.siteLeader.id,
                `You are now <span class='fw-bold'>Site Leader</span> for <b>${this.site.siteDetails.siteName}</b>`,
                'Organization', `home/organization/site-profile/view/${data['_id']}`);
            // send notifications to Opco Leader and HR Leader and HR Teams
            this.notificationService.sendNotification(this.organizationService.hrLeaderId,
                `Site <b>${this.site.siteDetails.siteName}</b> has been added `,
                'Organization', `home/organization/site-profile/view/${data['_id']}`);
            this.notificationService.sendNotification(this.organizationService.companyLeaderId,
                `Site <b>${this.site.siteDetails.siteName}</b> has been added `,
                'Organization', `home/organization/site-profile/view/${data['_id']}`);
            this.organizationService.hrTeamIds.forEach(hrId => {
                this.notificationService.sendNotification(hrId,
                    `Site <b>${this.site.siteDetails.siteName}</b> has been added `,
                    'Organization', `home/organization/site-profile/view/${data['_id']}`);
            });


            this.router.navigate(['/home/organization/profile/view', this.organizationId]);
            // this.matsnackBar.open('Site Created and Company Updated', '', {
            //     duration: 3000
            // });
            this.toastService.success();
        }, (error) => {
            // this.matsnackBar.open('Unable to create Site', '', {
            //     duration: 3000
            // });
            this.toastService.error('Unable to create Site');
        });
        // this.site = Site;
    }

    initialAssociates(event) {
        this.associateService.getAllAssociatesFilter(event ? event : 'a', 'initial').subscribe((data) => {
            this.autoCompleteAssociate = data;
        }, (error) => {
        });
    }

    managerTyped(fieldName: string) {
        this.keyCounterAssc++;
        this.site.contactDetails.siteLeader.id = '';
        this.site.contactDetails.siteLeader.groupId = '';

        if (this.keyCounterAssc >= 3) {
            this.associateService.getAllAssociatesFilter(this.site.contactDetails.siteLeader.name, '', '').pipe(
                debounceTime(500))
                .subscribe((data) => {
                    this.autoCompleteAssociate = data;
                }, (error) => {
                });
            this.keyCounterAssc = 0;
        }
    }

    validateAssociateAutocomplete(field: string, fieldValidate: string) {
        let asscObj: any = this.autoCompleteAssociate.filter((assc) => {
            return assc.personalInformation.fullName === this.site.siteDetails.siteLeader.name
        });
        if (asscObj.length === 0) {
            this[fieldValidate] = false;
        } else {
            this[fieldValidate] = true;
        }
    }

    clickDropDown(recievedAssociate: any, field: string) {
        this.site.contactDetails.siteLeader.name = recievedAssociate.personalInformation.fullName;
        this.site.contactDetails.siteLeader.id = recievedAssociate._id;
        this.site.contactDetails.siteLeader.groupId = recievedAssociate.groupId;
    }

    onTypeChange() {
        if (this.site.siteDetails.siteType === 'Physical') {
            this.sitePurposeDropDown = Object.assign([], this.physicalSiteList);
            this.site.siteDetails.sitePurpose = '';
        } if (this.site.siteDetails.siteType === 'Digital') {
            this.sitePurposeDropDown = Object.assign([], this.digitalSiteList);
            this.site.siteDetails.sitePurpose = '';
        }
    }

    addressInput(address: any) {
        if (address.field === 'physicalAddress') {
            this.site.siteDetails.physicalAddress.address1 = address.address.address1;
            this.site.siteDetails.physicalAddress.address2 = address.address.address2;
            this.site.siteDetails.physicalAddress.address3 = address.address.address3;
            this.site.siteDetails.physicalAddress.city = address.address.city;
            this.site.siteDetails.physicalAddress.zip = address.address.zip;
            this.site.siteDetails.physicalAddress.state = address.address.state;
            this.site.siteDetails.physicalAddress.country = address.address.country;
            for (let adf in this.site.siteDetails.physicalAddress) {
                if (this.site.siteDetails.physicalAddress.hasOwnProperty(adf)) {
                    if (this.site.siteDetails.physicalAddress[adf] == undefined) {
                        this.site.siteDetails.physicalAddress[adf] = '';
                    }
                }
            }
        }
        if (address.field === 'currentLocation') {
            this.site.siteDetails.currentLocation.address1 = address.address.address1;
            this.site.siteDetails.currentLocation.address2 = address.address.address2;
            this.site.siteDetails.currentLocation.address3 = address.address.address3;
            this.site.siteDetails.currentLocation.city = address.address.city;
            this.site.siteDetails.currentLocation.zip = address.address.zip;
            this.site.siteDetails.currentLocation.state = address.address.state;
            this.site.siteDetails.currentLocation.country = address.address.country;
            for (let adf in this.site.siteDetails.currentLocation) {
                if (this.site.siteDetails.currentLocation.hasOwnProperty(adf)) {
                    if (this.site.siteDetails.currentLocation[adf] == undefined) {
                        this.site.siteDetails.currentLocation[adf] = '';
                    }
                }
            }
        }
    }
}
